import PageTitle from "../../../layout/PageTitle";
import React, {useContext} from "react";
import {Alert, Container} from "react-bootstrap";
import {UserContext} from "../../../context/UserContext";
import ListTable from "../../shared/ListTable";
import {deleteItem, sendToAPI} from "../../../helpers/Api";
import {CustomButton, DeleteButton} from "../../../helpers/ButtonHelper";
import {useMutation} from "@apollo/client";
import {deleteAllCartItem, deleteCartItem, getCartItems, cutCartItem} from "./CartQueries";
import _groupBy from "lodash/groupBy"
import _sortBy from "lodash/sortBy"
import Loader from "../../shared/Loader";

const ShoppingList = () => {
  const { carts } = useContext(UserContext)
  const [deleteCall] = useMutation(deleteCartItem, { refetchQueries: [getCartItems] })
  const [cutCall] = useMutation(cutCartItem, { refetchQueries: [getCartItems] })
  const [deleteAllCall] = useMutation(deleteAllCartItem, { refetchQueries: [getCartItems] })

  const emptyCart = () => {
    if (window.confirm('Sunteți sigur?'))
      deleteAllCall()
  }

  let chartData = Object.values(carts.length > 0 ? _groupBy(carts, 'ingredient.name') : {})
  chartData = _sortBy(chartData, '[0].ingredient.name')
  chartData = _sortBy(chartData, '[0].cut')

  const cutItem = (event, id, gqlCall) => {
    event.preventDefault()
    const form = event.target;
    const data = { id: id }

    sendToAPI({ form, data, gqlCall })
  }

  const header = <tr>
    <th>#</th>
    <th>Produs</th>
    <th className='actions'></th>
  </tr>

  const listItem = (item, index) => (
    <tr key={index}>
      <td>
        {index + 1}
      </td>
      <td className={item[0].cut ? 'text-decoration-line-through' : ''}>
        <strong>{item[0].ingredient.name}</strong>
        {': '}
        {item.map(a => a.text).join(' + ')}
      </td>
      <td className='actions'>
        <CustomButton icon="cart-check" className='btn btn-outline-secondary'
                      text={item[0].cut ? 'Sterge din cos' : 'Adaugat in cos'}
                      onClick={e => cutItem(e, item[0].ingredientId, cutCall)} />
        <DeleteButton onClick={e => deleteItem(e, item[0].id, deleteCall)} />
      </td>
    </tr>
  )

  return (
    <Container>
      <PageTitle title='Cos de cumparaturi' buttons={
        <DeleteButton text="Goleste cosul" showText={true} size='md' onClick={emptyCart} />
      } />
      <div className="row justify-content-md-center">
        <div className="page-container col">
          {chartData
            ?
            chartData.length > 0
              ?
              <ListTable data={chartData} header={header} listItem={listItem} searchFields={['0.ingredient.name']} />
              :
              <Alert variant='warning'>Cosul de cumparaturi este gol</Alert>
            :
            <Loader />
          }
        </div>
      </div>
    </Container>
  );
}

export default ShoppingList;
